import Link from 'next/link'

const RelatedPosts = ({ posts }: { posts: any }) => {
  return <div className="related-posts-container">
    <div className="header mb-10 text-xl pl-3 pt-7">
      <strong>Related</strong>
    </div>
    <div className="flex flex-wrap posts-list">
    {posts.map((post: any) => {
      return <div
        key={post.sys?.id}
        className="post-container mb:w-1/2 dt:w-1/4 px-2 mb-10">
        <Link href={`/blogs/${post.fields?.blogUrl}`}>
          <div className="img-container">
            <img
              className="dt:h-[30vh] mb:h-[20vh] cursor-pointer"
              src={`https:${post.fields?.thumbnail?.fields?.file?.url}`}
            />
          </div>
        </Link>
        <div className="post-title mb:text-sm mt-2 text-left">{post.fields?.blogTitle}</div>
        <div className="post-type font-soehne-xleight">{post.fields?.blogType}</div>
      </div>
    })}
    </div>
  </div>
}

export default RelatedPosts;
